import '.c3{position:relative;}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.af{border-radius:1.25rem;}.ssr-plugin'
import '.a6{overflow:hidden;}.ssr-plugin'
import '.i{width:100%;}.ssr-plugin'
import '.hm{height:20rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c2{user-select:none;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Follower } from '@app/types/Follower'
import { AvatarStack } from '../avatarStack/AvatarStack'
import Column from '@app/components/layout/Column'
import { RegionStatusRow } from './blocks/RegionStatusRow'
import { Image } from '@app/components/core/image/Image'

export interface HousingFormCardProps {
  image: string
  title: string
  followers: Array<Follower>
  followerCount: number
  initiativeCount?: number
  style?: Style
  onClick?: () => void
}

export const HousingFormCard = ({
  image,
  title,
  followers,
  followerCount,
  initiativeCount,
  style,
  onClick,
}: HousingFormCardProps) => {
  return (
    <styled.div className="c3 ag af a6 i hm a b c2"
      data-testid="housing-form-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        ...style,
      }}
    >
      {/* Main Image */}
      <Image
        src={image}
        resizeWidth={800}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
        }}
      />

      {/* Overlay with Title and Profile Icons */}
      <Column
        style={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          background:
            'linear-gradient(180deg, rgba(45, 31, 21, 0.00) 0%, #28220D 100%)',
          padding: '1.5rem',
        }}
      >
        {/* Title */}
        <Title.H3
          style={{
            color: 'var(--shades-white)',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            wordBreak: 'break-word',
            margin: 0,
          }}
        >
          {title}
        </Title.H3>

        {initiativeCount ? (
          <RegionStatusRow initiatives={initiativeCount} version="light" />
        ) : null}

        {/* Profile Icons and Follower Count */}
        <AvatarStack
          size={'extra-small'}
          avatars={followers}
          total={followerCount}
          version="light"
          style={{
            marginTop: '0.5rem',
          }}
        />
      </Column>
    </styled.div>
  )
}
